import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn.tsx';
import {
	createSingleLineHeader,
	SINGLE_LINE_STYLE,
} from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/singleLine.ts';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { Flex, Text } from '@mantine/core';
import { InvestmentDetailsLegalDocument } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import {
	MAX_VISIBLE_SIGNERS_TABLE,
	getDocumentStatusProps,
	renderSigners,
} from './InvestmentLegalDocuments.utils.tsx';

interface Props {
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>;
	onUnassignedSignerClick?: (documentId: string) => void;
}

export const getInvestmentLegalDocumentsTableColumns = ({
	tMipManage,
	onUnassignedSignerClick,
}: Props): ExtendedColumnDef<InvestmentDetailsLegalDocument>[] => [
	createTextColumn<InvestmentDetailsLegalDocument>({
		id: 'documentName',
		accessorKey: 'name',
		header: createSingleLineHeader<InvestmentDetailsLegalDocument>(
			tMipManage('investment_legal_documents_table.columns.document_name')
		),
		size: 260,
		minSize: 200,
		columnLabel: tMipManage('investment_legal_documents_table.columns.document_name'),
		enableSorting: true,
	}),

	{
		id: 'signers',
		header: createSingleLineHeader<InvestmentDetailsLegalDocument>(
			tMipManage('investment_legal_documents_table.columns.signers'),
			{ enableSorting: false }
		),
		columnLabel: tMipManage('investment_legal_documents_table.columns.signers'),
		enableSorting: false,
		size: 260,
		minSize: 240,
		cell: ({ row }) => (
			<Flex gap="1rem" align="center" wrap="nowrap">
				{renderSigners({
					signers: row.original.signers,
					documentId: row.original.id,
					onUnassignedSignerClick,
					maxVisible: MAX_VISIBLE_SIGNERS_TABLE,
				})}
			</Flex>
		),
	},

	{
		id: 'status',
		header: createSingleLineHeader<InvestmentDetailsLegalDocument>(
			tMipManage('investment_legal_documents_table.columns.status')
		),
		columnLabel: tMipManage('investment_legal_documents_table.columns.status'),
		enableSorting: true,
		size: 180,
		minSize: 170,
		accessorFn: (row) => row.status,
		cell: ({ row }) => {
			const { text, statusTextColor } = getDocumentStatusProps(
				row.original.status,
				tMipManage
			);
			return (
				<Flex align="center" gap="0.25rem" wrap="nowrap" miw={0}>
					<Text c={statusTextColor} fz="lg" lh={1} style={{ flexShrink: 0 }}>
						•
					</Text>

					<Text c={statusTextColor} truncate style={SINGLE_LINE_STYLE}>
						{text}
					</Text>
				</Flex>
			);
		},
	},
];
